$( document ).ready(function() {

  // $("html").bind("DOMSubtreeModified", function() {
  //   if ($(".__jivoMobileButton")[0]){
  //     $(".__jivoMobileButton").hide();
  //   }

  //   if ($("#jvlabelWrap")[0]){
  //     $("#jvlabelWrap").hide();
  //   }

  // });

  function copyToClipboard(element) {
    var $temp = $("<input>");
    var oldValue = $(element).html();
    $("body").append($temp);
    $temp.val($(element).html()).select();
    document.execCommand("copy");
    $(element).html("COPIADO");
    setTimeout(function () {
      $(element).html(oldValue);
    }, 300);
    $temp.remove();
  }
  $("font").click(function () {
    copyToClipboard(this);
  });
  
//   if($('.product-bundles__list').length){
//     $('.product-bundles__list').slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       prevArrow: '<button type="button" aria-label="Previous Product" class="slick-prev slick-arrow" aria-disabled="false" style="display: block;"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>',
//       nextArrow: '<button type="button" aria-label="Next Product" class="slick-next slick-arrow" style="display: block;" aria-disabled="false"><svg viewBox="0 0 50 50"><path d="M 11.957031 13.988281 C 11.699219 14.003906 11.457031 14.117188 11.28125 14.308594 L 1.015625 25 L 11.28125 35.691406 C 11.527344 35.953125 11.894531 36.0625 12.242188 35.976563 C 12.589844 35.890625 12.867188 35.625 12.964844 35.28125 C 13.066406 34.933594 12.972656 34.5625 12.71875 34.308594 L 4.746094 26 L 48 26 C 48.359375 26.003906 48.695313 25.816406 48.878906 25.503906 C 49.058594 25.191406 49.058594 24.808594 48.878906 24.496094 C 48.695313 24.183594 48.359375 23.996094 48 24 L 4.746094 24 L 12.71875 15.691406 C 13.011719 15.398438 13.09375 14.957031 12.921875 14.582031 C 12.753906 14.203125 12.371094 13.96875 11.957031 13.988281 Z"></path></svg></button>'
//     });
//   }

  /*Featured Collection*/
  $('.new-grid .grid-product .products-grid').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesPerRow: 2,
    slidesToScroll: 1,
    rows: 2,
    arrows: true,
    prevArrow: '<button type="button" aria-label="Previous Product" class="slick-prev slick-arrow slick-disabled" aria-disabled="true" style="display: block;"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" aria-label="Next Product" class="slick-next slick-arrow" style="display: block;" aria-disabled="false"><i class="fa fa-angle-right"></i></button>',
  
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          slidesPerRow: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          slidesPerRow: 2,
          arrows: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  
});